import http from '@/utils/http';

const baseUrl = '/unidade-medida';

export default {
    buscarTodas() {
        return http.get({
            url: baseUrl,
            lockScreen: false
        });
    }
};
